export enum Path {
  HOME = '/',
  ANALYSIS_FLOW = '/flow',
  NOT_FOUNT = '*',
}
